import React from 'react';
import classNames from 'classnames/index';
import { WizardStepContainer, WizardStepTitle } from './partials';
import { useLocalizedMessage } from '../../../../../util/useLocalizedMessage';

const imageUrl = require('assets/wizard/wizard-dev.png');
const iconDev1 = require('assets/wizard/icon-dev-1.svg');
const iconDev2 = require('assets/wizard/icon-dev-2.svg');
const iconDev3 = require('assets/wizard/icon-dev-3.svg');

const WizardDevTestDetectionStep = () => {
  const localizeMessage = useLocalizedMessage();
  return (
    <div className={classNames('wizard-step', 'wizard-step-dev')}>
      <WizardStepContainer>
        <div className="row">
          <div className="col-12">
            <div className="image-container">
              <img className="image" src={imageUrl} alt="" />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-12">
            <WizardStepTitle title={localizeMessage('wizard.dev.title')} />
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12 text-block">
            <p className="text-block__primary">
              {localizeMessage('wizard.dev.text.line1')}
            </p>
            <p className="text-block__primary">
              {localizeMessage('wizard.dev.text.line2')}
            </p>
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-4">
            <div className="wizard-card">
              <img className="icon" src={iconDev2} alt="" />
              <p className="wizard-card__text">
                {localizeMessage('wizard.dev.card.migration')}
              </p>
            </div>
          </div>
          <div className="col-4">
            <div className="wizard-card highlighted">
              <img className="icon" src={iconDev1} alt="" />
              <p className="wizard-card__text">
                <span className="text-accent">
                  {localizeMessage('wizard.dev.card.trial')}
                </span>
                {' '}
                {localizeMessage('wizard.dev.card.trial.domain')}
              </p>
            </div>
          </div>
          <div className="col-4">
            <div className="wizard-card">
              <img className="icon" src={iconDev3} alt="" />
              <p className="wizard-card__text">
                {localizeMessage('wizard.dev.card.services')}
              </p>
            </div>
          </div>
        </div>
      </WizardStepContainer>
    </div>
  );
};

export default WizardDevTestDetectionStep;
